module.exports = __webpack_public_path__ + "static/media/info-process-icon.3b5f766d.svg";